import { apiFetch, setToken, clearToken } from './client';

export async function login(username, password) {
  const data = await apiFetch('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ username, password }),
  });
  setToken(data.access_token);
  localStorage.setItem('aspyn_user', JSON.stringify({
    username: data.username,
    role: data.role,
    permissions: data.permissions,
  }));
  return data;
}

export async function fetchMe() {
  return apiFetch('/auth/me');
}

export function logout() {
  clearToken();
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem('aspyn_user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
